import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofFlags = () => {

    const servicesFaqData = [
      {
        question: "What customisation options are available for flag printing?",
        answer: "Printingy offers complete customisation for custom flag printing, including sizes, shapes, colours, and materials. You can include logos, messages, or unique designs tailored to your branding needs."
    },
    {
        question: "Can Printingy handle bulk orders for flag printing?",
        answer: "Yes, Printingy specialises in bulk flag printing, ensuring consistent quality and competitive pricing for large-scale orders. Our services are ideal for businesses, events, and promotional campaigns."
    },
    {
        question: "What materials are used for banner and flag printing?",
        answer: "We use high-quality, durable fabrics such as polyester and vinyl for flag printing services. These weather-resistant materials ensure longevity and vibrant visuals for indoor and outdoor use."
    },
    {
        question: "Are flags suitable for outdoor use?",
        answer: "Yes, our custom flag printing services produce weatherproof and UV-resistant flags, perfect for outdoor events, advertising, and branding campaigns."
    },
    {
        question: "What is the turnaround time for bulk flag printing orders?",
        answer: "The turnaround time for Printing Flags depends on the order size and customisation level. Standard bulk orders are typically completed within a few business days, with expedited options available for urgent projects."
    },
    {
        question: "How can I design custom flags for my business?",
        answer: "Printingy provides professional design assistance for custom flag printing. Our team works with you to create visually appealing and impactful flag designs that align with your branding requirements."
    },
    {
        question: "What types of flags can Printingy print?",
        answer: "Printingy offers flag printing services for various needs, including corporate flags, event flags, promotional banners, and custom outdoor advertising flags."
    },
    {
        question: "How durable are printed flags?",
        answer: "Our flags printing solutions use high-quality materials to withstand outdoor conditions such as wind, sunlight, and rain. This ensures long-term durability and fade-resistant visuals."
    },
    {
        question: "Can I include both banners and flags in a single order?",
        answer: "Yes, our banner and flag printing services allow you to combine both options in bulk. This provides a cohesive solution for branding across events, promotions, and outdoor campaigns."
    },
    {
        question: "How do I place an order for custom flag printing?",
        answer: "Placing an order is easy. Visit our website, select your specifications for flag printing service, upload your artwork, and confirm your details. Our team ensures seamless production and on-time delivery."
    }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Flags');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes
    
  return (
    <div>
    <MetaManager 
  title="Custom Flags Printing Services for Events and Promotions"
  description="Professional printing of flags for events, branding, and advertising. Bulk custom flag printing, flag printing services, and banner and flag printing solutions."
  keywords="Printing of Flags,
Flags Printing,
Flag Printing Service,
Custom Flags Printing,
Banner and Flags Printing"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Flags</h1>
              <h2 className="text-muted">
              Custom flags printing for branding, events, and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Flags are versatile for enhancing brand visibility, advertising campaigns, and events. Printingy specialises in the Printing of Flags, offering high-quality flag printing services for businesses, events, and corporate branding.</p>
          <p>Our custom flags printing solutions allow you to showcase logos, messages, and designs on premium materials, ensuring sharp visuals and vibrant colours. From corporate flags to event banners, our banner and flag printing services cater to large-scale requirements with precision and consistency.</p>
          <p>With bulk printing capabilities and quick turnaround times, Printingy delivers cost-effective flag printing solutions that meet your promotional and branding goals.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Flag Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and professional flags for promotions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Flags for corporate branding, events, and promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk flag printing for large-scale orders at cost-effective rates.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom flag printing to meet your unique requirements.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional flag printing service with vibrant visuals and durable materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced banner and flag printing technology ensuring precision and consistency.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-quality, weather-resistant fabrics are suitable for indoor and outdoor use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick production turnaround for bulk and urgent projects.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, event organisers, and corporate clients nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/flagprinting.jpg" // Path relative to the public folder
                  alt="Professional printing of flags services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Flags Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your custom flag printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with durable materials to produce exceptional custom flag printing. Our flag printing service guarantees sharp, fade-resistant visuals if you need flags for outdoor advertising, trade shows, or corporate events.</p>
            <p>With streamlined processes and bulk production capabilities, we ensure timely delivery without compromising quality. Printingy is your trusted partner for reliable, impactful banner and flag printing solutions.</p>
          </div>
        </Container>
      </section>



      <div>
 
  <OtherServicesCarousel />
 
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofFlags;
